import orderResource from "../resources/orderResource";
import Order from "../domain/order";

export default {
  newOrder(customer, date, products) {
    const items = [];
    products.forEach((product => items.push({ product, amount: 0, returns: 0})));
    return new Order({customer, date, items, note: customer.note});
  },
  async findByDate (date) {
    const response = await orderResource.query({date: date.format('YYYY-MM-DD')});
    if (response.ok) {
      const data = response.data.map((orderData) => new Order(orderData));
      return data;
    } else {
      return null;
    }
  },
  async findByDateRange (dateFrom, dateTo) {
    const response = await orderResource.query({dateFrom: dateFrom.format('YYYY-MM-DD'), dateTo: dateTo.format('YYYY-MM-DD')});
    if (response.ok) {
      return response.data.map((orderData) => new Order(orderData));
    } else {
      return null;
    }
  },
  async create (order) {
    const response = await orderResource.save({}, order);
    if (response.ok) {
      return new Order(response.data);
    } else {
      return null;
    }
  },
  async update (order) {
    const response = await orderResource.update({}, order);
    if (response.ok) {
      return new Order(response.data);
    } else {
      return null;
    }
  }
}



// WEBPACK FOOTER //
// ./client/services/orderService.js